import { Controller } from "@hotwired/stimulus";

const ATTACH_BUTTON_MARKER = "data-support-ticket-attach-button";

// Compact Trix editor for operator support ticket replies:
// blocks inline file uploads and adds attach button in toolbar.
export default class extends Controller {
  connect() {
    this.editorElement = this.element.querySelector("trix-editor");
    this.boundFileAccept = (event) => event.preventDefault();
    this.boundTrixInitialize = () => this.injectAttachButton();

    this.element.addEventListener("trix-file-accept", this.boundFileAccept);

    if (this.editorElement) {
      this.editorElement.addEventListener(
        "trix-initialize",
        this.boundTrixInitialize,
      );
      this.injectAttachButton();
    }
  }

  disconnect() {
    this.element.removeEventListener("trix-file-accept", this.boundFileAccept);

    if (this.editorElement) {
      this.editorElement.removeEventListener(
        "trix-initialize",
        this.boundTrixInitialize,
      );
    }
  }

  injectAttachButton() {
    const toolbar = this.element.querySelector("trix-toolbar");
    if (!toolbar || toolbar.querySelector(`[${ATTACH_BUTTON_MARKER}]`)) return;

    const blockTools = toolbar.querySelector(".trix-button-group--block-tools");
    if (!blockTools) return;

    const button = document.createElement("button");
    button.type = "button";
    button.className = "trix-button trix-button--icon trix-button--icon-attach";
    button.title = "Adjuntar archivos";
    button.setAttribute("aria-label", "Adjuntar archivos");
    button.tabIndex = -1;
    button.setAttribute(ATTACH_BUTTON_MARKER, "");
    button.textContent = "Adjuntar archivos";
    button.addEventListener("click", (event) => {
      event.preventDefault();
      this.openAttachmentsDialog();
    });

    blockTools.appendChild(button);
  }

  openAttachmentsDialog() {
    const composer = this.element.querySelector(
      "[data-controller~='multi-file-attachments']",
    );
    if (!composer) return;

    const attachmentsController =
      this.application.getControllerForElementAndIdentifier(
        composer,
        "multi-file-attachments",
      );

    attachmentsController?.openDialog();
  }
}
